var bannerInstagram;
function repositionInstagram() {
  if ($(".instagram-widget").length) {
    if ($(".in-index").length) {
      createInstagramBlock();
    } else {
      createInstagramBlock();
    }
  }
}

function createInstagramBlock() {
  var instagramBlock = $(".instagram-widget");
  var instagramContainer = `
		<div class="content-wrapper instagram-block js-instagram-block">
		</div>
	`;

  $(".instagram-widget").closest("div").parent().remove();
  $(instagramContainer).insertBefore("#footer");
  $(".js-instagram-block").append(instagramBlock);

  $(".js-instagram-block .instagram-widget > a").wrap(
    '<div class="instagram-widget-item"></div>'
  );

  $(".instagram-block").prepend(
    '<div class="h4 homepage-group-title">SLEDUJTE NÁS NA INSTAGRAME</div><span class="instagram-subheadline"><a href="https://www.instagram.com/chrusticek.eu" target="_blank">@chrusticek.eu</a></span>'
  );
}
